var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition"},[_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{attrs:{"sizes":"60rem","src":_vm.src,"srcset":_vm.srcset}})
}]

export { render, staticRenderFns }